
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import jwt_decode from "jwt-decode";
export interface User{
    refresh_token: any;
    id?: number;
    username: string;
    password: string;
    firstName?: string;
    lastName?: string;
    token?: string;
    user_type? : string;
}

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private apiUrl = environment.apiUrl
    private apiVersion = environment.apiVersion
    private headers:any;
    constructor(private http: HttpClient,
        private router:Router,
        private sharedService: SharedService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentLoginUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(data,instanceId: any) {
        const headersWithInstanceId = this.headers.set('X-Instance-Id', `${instanceId}`);
        return this.http.post<any>(`${this.apiUrl}/${this.apiVersion}/login?instance_id_q=${instanceId}`, data, {headers:headersWithInstanceId})
            .pipe(map(user => {
                if (user['status']) {
                    return user;
                }
                this.dataFunc(user);
                return user;
            }));
    }
    resendOTP(username){
        let instanceId = JSON.parse(sessionStorage.getItem('instanceConfig'))?.InstanceModel?.idinstance;
        const headersWithInstanceId = this.headers.set('X-Instance-Id', `${instanceId}`);
        return this.http.post<any>(`${this.apiUrl}/${this.apiVersion}/resendOTP`,{'username':username},{headers:headersWithInstanceId}).pipe(retry(3));
    }
    verifyOTP(otpObj){
        let instanceId = JSON.parse(sessionStorage.getItem('instanceConfig'))?.InstanceModel?.idinstance;
        const headersWithInstanceId = this.headers.set('X-Instance-Id', `${instanceId}`);
        return this.http.post<any>(`${this.apiUrl}/${this.apiVersion}/verifyOTP`,otpObj,{headers:headersWithInstanceId})
        .pipe(map(user => {
            if(user == "invalid" || user == "otp expired"){
                return user;
            }
            this.dataFunc(user);
            return user;
        }));
    }

    dataFunc(user){
        const decoded_permission = jwt_decode(user?.x_api_token);
        const decoded_user = jwt_decode(user?.token);
        user.permissioninfo= decoded_permission["sub"];
        user.userdetails = decoded_user["sub"];
        // store user details and jwt token in session storage to keep user logged in between page refreshes
        if(user.permissioninfo.isConfigPortal === 1){
            const userData = sessionStorage.setItem('currentLoginUser', JSON.stringify(user));
            this.sharedService.userId = user.userdetails?.idUser;
            this.currentUserSubject.next(user);
        }
    }
    refreshToken(){
        let data = {
            "grant_type": "refresh_token",
            "refresh_token": this.currentUserValue.refresh_token
          }
          
        let instanceId = JSON.parse(sessionStorage.getItem('instanceConfig'))?.InstanceModel?.idinstance;
        const headersWithInstanceId = this.headers.set('X-Instance-Id', `${instanceId}`);
        return this.http.post(`${this.apiUrl}/${this.apiVersion}/token`,data,{headers:headersWithInstanceId}).pipe(
        map((data:any)=>{
            const newAccessToken = data.token;
            this.currentUserValue.token = newAccessToken;
            sessionStorage.setItem('currentLoginUser', JSON.stringify(this.currentUserValue))
        })  ,retry(3)
       );
    }
    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentLoginUser');
        sessionStorage.removeItem('instanceConfig');
        sessionStorage.removeItem('configData');
        this.router.navigate(['/login'])
        this.currentUserSubject.next(null);
    }
}